module.exports = __webpack_public_path__ + "img/9.7692f67.png";